export const CityLocations = [
    { 'name': '甲田町', 'lat': 34.695473, 'long': 132.759681 },
    { 'name': '高宮町', 'lat': 34.767078, 'long': 132.72002 },
    { 'name': '美土里町', 'lat': 34.726698, 'long': 132.627318 },
    { 'name': '向原町', 'lat': 34.613374, 'long': 132.71897 },
    { 'name': '八千代町', 'lat': 34.620299, 'long': 132.607853 },
    { 'name': '吉田町', 'lat': 34.666027, 'long': 132.704021 },
];

export const DefaultLocation: [number, number] = [34.666523, 132.703694];